(() => {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');
  const strings = JSON.parse(document.getElementById('ThemeStrings')?.textContent || '{}');
  const root = (document.body.dataset.root || '/').replace(/\/$/, '') + '/';
  const status = text => { const live = document.getElementById('LiveStatus'); if (live) live.textContent = text; };
  const modal = id => { const dialog = document.getElementById(id); if (dialog && !dialog.open) dialog.showModal(); return dialog; };
  let lastTrigger = null;
  const close = dialog => { dialog?.close(); if (lastTrigger?.isConnected) lastTrigger.focus(); };
  const responseJSON = async response => {
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || strings.error);
    return data;
  };
  let cartBusy = false;
  const updateCount = count => document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = count);
  const updateDrawer = html => {
    if (!html) throw new Error(strings.error);
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = parsed.querySelector('[data-cart-content]');
    if (!content) throw new Error(strings.error);
    document.querySelector('#CartDrawer [data-cart-content]')?.replaceWith(content);
  };
  const refreshCart = async () => {
    const [cart, sections] = await Promise.all([
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(responseJSON),
      fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' }).then(responseJSON)
    ]);
    updateCount(cart.item_count); updateDrawer(sections['cart-drawer']);
  };
  document.addEventListener('click', async event => {
    const open = event.target.closest('[data-open]');
    if (open) { lastTrigger = open; if (open.dataset.open === 'WishlistDialog') renderWishlist(); modal(open.dataset.open); }
    const closer = event.target.closest('[data-close]');
    if (closer) close(closer.closest('dialog'));
    const cartOpen = event.target.closest('[data-cart-open]');
    if (cartOpen) {
      event.preventDefault(); lastTrigger = cartOpen; modal('CartDrawer');
      try { await refreshCart(); } catch (error) { const target = document.querySelector('[data-cart-error]'); if (target) target.textContent = strings.error; }
    }
    const quantity = event.target.closest('[data-cart-quantity]');
    if (quantity && !cartBusy) {
      cartBusy = true;
      const drawer = document.getElementById('CartDrawer');
      drawer.setAttribute('aria-busy', 'true');
      drawer.querySelectorAll('[data-cart-quantity]').forEach(el => el.disabled = true);
      try {
        const data = await fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: quantity.dataset.key, quantity: Number(quantity.dataset.cartQuantity), sections: ['cart-drawer'], sections_url: location.pathname }) }).then(responseJSON);
        updateCount(data.item_count);
        if (data.sections?.['cart-drawer']) updateDrawer(data.sections['cart-drawer']); else await refreshCart();
        status(strings.updated);
        drawer.querySelector('[data-close]')?.focus();
      } catch (error) { drawer.querySelector('[data-cart-error]').textContent = error.message; }
      finally { cartBusy = false; drawer.removeAttribute('aria-busy'); drawer.querySelectorAll('[data-cart-quantity]').forEach(el => el.disabled = false); }
    }
    const zoom = event.target.closest('[data-zoom]');
    if (zoom) { lastTrigger = zoom; const img = document.querySelector('[data-zoom-image]'); img.src = zoom.dataset.zoom; img.alt = zoom.dataset.alt || ''; modal('ZoomDialog'); }
    const saved = event.target.closest('[data-wishlist]');
    if (saved) toggleWishlist(saved);
    const remove = event.target.closest('[data-remove-wishlist]');
    if (remove) { wishlist = wishlist.filter(item => item.handle !== remove.dataset.removeWishlist); writeWishlist(); renderWishlist(); syncWishlist(); status(strings.removed); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.product-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[name=add]');
    if (!button || button.disabled) return;
    const label = button.textContent; button.disabled = true; button.textContent = strings.adding;
    const errorBox = form.querySelector('[data-product-error]'); errorBox.textContent = '';
    const data = new FormData(form); data.set('sections', 'cart-drawer'); data.set('sections_url', location.pathname);
    let added = false;
    try {
      const result = await fetch(root + 'cart/add.js', { method: 'POST', body: data, credentials: 'same-origin' }).then(responseJSON);
      added = true;
      if (result.sections?.['cart-drawer']) updateDrawer(result.sections['cart-drawer']);
      await refreshCart(); lastTrigger = button; modal('CartDrawer'); status(strings.added);
    } catch (error) {
      if (added) { location.assign(root + 'cart'); return; }
      errorBox.textContent = error.message;
    } finally { button.disabled = false; button.textContent = label; }
  });
  let variantController;
  document.addEventListener('change', async event => {
    const option = event.target.closest('[data-product-option]');
    if (!option) return;
    const region = option.closest('[data-product-root]');
    const focusID = option.id;
    const url = new URL(region.dataset.productUrl, location.origin);
    url.searchParams.set('section_id', region.dataset.sectionId);
    url.searchParams.set('option_values', [...region.querySelectorAll('[data-product-option]')].map(x => x.value).join(','));
    variantController?.abort(); variantController = new AbortController();
    region.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, { signal: variantController.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error(strings.error);
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = parsed.querySelector('[data-product-root]');
      if (!next) throw new Error(strings.error);
      region.replaceWith(next); initialize(next); document.getElementById(focusID)?.focus();
      const variant = next.querySelector('[data-variant-id]')?.value;
      const pageURL = new URL(location.href); pageURL.searchParams.delete('option_values');
      if (variant) pageURL.searchParams.set('variant', variant); else pageURL.searchParams.delete('variant');
      history.replaceState({}, '', pageURL);
    } catch (error) { if (error.name !== 'AbortError') { region.querySelector('[data-product-error]').textContent = strings.error; const addButton = region.querySelector('[name=add]'); if (addButton) addButton.disabled = true; } }
    finally { region.removeAttribute('aria-busy'); }
  });
  let wishlist = [];
  try { wishlist = JSON.parse(localStorage.getItem('mobilier_favorites_v1') || '[]'); if (!Array.isArray(wishlist)) wishlist = []; wishlist = wishlist.filter(x => typeof x.handle === 'string' && typeof x.url === 'string'); } catch { wishlist = []; }
  const writeWishlist = () => { try { localStorage.setItem('mobilier_favorites_v1', JSON.stringify(wishlist.slice(0,100))); } catch { status(strings.error); } };
  const syncWishlist = () => document.querySelectorAll('[data-wishlist]').forEach(el => el.setAttribute('aria-pressed', String(wishlist.some(x => x.handle === el.dataset.wishlist))));
  const toggleWishlist = el => {
    const existing = wishlist.some(x => x.handle === el.dataset.wishlist);
    if (existing) wishlist = wishlist.filter(x => x.handle !== el.dataset.wishlist);
    else wishlist.push({ handle: el.dataset.wishlist, title: el.dataset.title, url: el.dataset.url, image: el.dataset.image });
    writeWishlist(); syncWishlist(); status(existing ? strings.removed : strings.saved);
  };
  const safeURL = (url, image = false) => {
    try { const parsed = new URL(url, location.origin); if (!['https:', 'http:'].includes(parsed.protocol)) return ''; if (!image && parsed.origin !== location.origin) return ''; return parsed.href; } catch { return ''; }
  };
  const renderWishlist = () => {
    const target = document.querySelector('[data-wishlist-content]'); if (!target) return; target.replaceChildren();
    if (!wishlist.length) { const p = document.createElement('p'); p.className = 'empty-state'; p.textContent = strings.empty; target.append(p); }
    wishlist.forEach(item => {
      const row = document.createElement('article'); row.className = 'wishlist-item';
      const picture = document.createElement('img'); picture.src = safeURL(item.image, true); picture.alt = item.title || ''; picture.width = 80; picture.height = 80; picture.loading = 'lazy';
      const a = document.createElement('a'); a.href = safeURL(item.url); a.textContent = item.title;
      const b = document.createElement('button'); b.className = 'small-link'; b.type = 'button'; b.textContent = strings.remove; b.dataset.removeWishlist = item.handle;
      if (item.image && picture.src) row.append(picture); else row.append(document.createElement('span'));
      row.append(a,b); target.append(row);
    });
  };
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-variant-id]').forEach(el => el.disabled = !el.value);
    scope.querySelectorAll('dialog').forEach(dialog => {
      if (dialog.dataset.initialized) return; dialog.dataset.initialized = 'true';
      dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(dialog); } });
      dialog.addEventListener('cancel', () => { if (lastTrigger?.isConnected) lastTrigger.focus(); });
    });
    syncWishlist();
    scope.querySelectorAll('[data-recommendations]').forEach(async el => {
      if (el.dataset.loaded || !el.dataset.url) return; el.dataset.loaded = 'true';
      try { const r = await fetch(el.dataset.url); if (!r.ok) return; const doc = new DOMParser().parseFromString(await r.text(), 'text/html'); const content = doc.querySelector('[data-recommendations]'); if (content?.querySelector('.product-card')) { el.innerHTML = content.innerHTML; syncWishlist(); } else el.hidden = true; } catch { el.hidden = true; }
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', e => initialize(e.target));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') document.querySelectorAll('details.nav-dropdown[open]').forEach(el => el.open = false); });
  document.addEventListener('click', e => { if (!e.target.closest('.nav-dropdown')) document.querySelectorAll('details.nav-dropdown[open]').forEach(el => el.open = false); });
})();
